import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';
import { customerProductParam, orgIdParam } from './builderHelper';

export const organizationProductResources = {
  getOrganizationProducts: createResourceBuilder(
    '/licensing/org/:organization_id/product',
    EResourceMethod.Get,
    orgIdParam()
  ),
  createOrganizationProduct: createResourceBuilder(
    '/licensing/org/:organization_id/product',
    EResourceMethod.Post,
    orgIdParam()
  ),
  getPlansAvailable: createResourceBuilder(
    '/licensing/org/:organization_id/product/new',
    EResourceMethod.Get,
    orgIdParam()
  ),
  getOrganizationProduct: createResourceBuilder(
    '/licensing/org/:organization_id/product/:customer_product_id',
    EResourceMethod.Get,
    orgIdParam(customerProductParam())
  ),
  getOrganizationProductLicenses: createResourceBuilder(
    '/licensing/org/:organization_id/product/:customer_product_id/license',
    EResourceMethod.Get,
    orgIdParam(customerProductParam())
  ),
  getOrganizationLicensesMetadata: createResourceBuilder(
    '/licensing/org/:organization_id/licenses/metadata',
    EResourceMethod.Post,
    orgIdParam()
  ),
  renewOrganizationProduct: createResourceBuilder(
    '/licensing/org/:organization_id/product/:customer_product_id/renew',
    EResourceMethod.Post,
    orgIdParam(customerProductParam())
  ),
  updateOrganizationProduct: createResourceBuilder(
    '/licensing/org/:organization_id/product/:customer_product_id',
    EResourceMethod.Put,
    orgIdParam(customerProductParam())
  ),
  suspendOrganizationProduct: createResourceBuilder(
    '/licensing/org/:organization_id/product/:customer_product_id/suspend',
    EResourceMethod.Post,
    orgIdParam(customerProductParam())
  ),
  reinstateOrganizationProduct: createResourceBuilder(
    '/licensing/org/:organization_id/product/:customer_product_id/reinstate',
    EResourceMethod.Post,
    orgIdParam(customerProductParam())
  ),
  releaseOrganizationProduct: createResourceBuilder(
    /** @todo */
    '/admin/customers/:organization_name/products/:customer_product_id/release',
    EResourceMethod.Post,
    (organization_name: string, product_id: number) => ({ organization_name, product_id })
  ),
  revokeOrganizationProduct: createResourceBuilder(
    '/licensing/org/:organization_id/product/:customer_product_id',
    EResourceMethod.Delete,
    orgIdParam(customerProductParam())
  ),
  renewOrganizationProducts: createResourceBuilder(
    '/licensing/org/:organization_id/products/renew',
    EResourceMethod.Post,
    orgIdParam()
  ),
  updateOrganizationProducts: createResourceBuilder(
    '/licensing/org/:organization_id/products',
    EResourceMethod.Put,
    orgIdParam()
  ),
  getDealHistory: createResourceBuilder(
    '/licensing/org/:organization_id/product/:product_id/deal-history',
    EResourceMethod.Get,
    orgIdParam((product_id: number) => ({ product_id }))
  ),
};
